import { CategoryTag } from "@/pages/delays/shared/components/CategoryTag";
import { dxtToLocalServerTime, getMomentTz } from "@dexteel/mesf-core";
import { ColDef } from "ag-grid-enterprise";
import "moment-duration-format";

const moment = getMomentTz();

export const useTableData = () => {
	const columnDefs: ColDef[] = [
		{
			field: "Start",
			headerName: "Start",
			valueGetter: (params) =>
				dxtToLocalServerTime(params.data?.Start, "HH:mm:ss") || "",
			flex: 1,
			sortable: true,
		},
		{
			field: "End",
			headerName: "End",
			valueGetter: (params) =>
				dxtToLocalServerTime(params.data?.End, "HH:mm:ss") || "",
			flex: 1,
			sortable: true,
		},
		{
			field: "Duration",
			headerName: "Duration",
			valueFormatter: (params) => {
				if (params.value) {
					const duration = moment.duration(params.value, "seconds");
					return duration.format("w[w] d[d] h[h] m[m]", { trim: "both" });
				}
				return "";
			},
			flex: 1,
			sortable: true,
		},
		{
			field: "DelayCategory",
			headerName: "Category",
			valueGetter: (params) => {
				const delayCategoryName = params.data?.DelayCategoryName;
				const delayCategoryColor = params.data?.DelayCategoryColor;
				return { name: delayCategoryName, color: delayCategoryColor };
			},
			cellRenderer: CategoryTag,
			flex: 1,
			sortable: true,
		},
		{
			field: "DelayCodePath",
			headerName: "Code",
			valueGetter: (params) => {
				const delayCodeName = params.data?.DelayCodeName;
				const delayCodePath = params.data?.DelayCodePath;

				const isSystemDelayCode =
					delayCodeName === "Adjustment" ||
					delayCodeName === "Undeclared Mill" ||
					delayCodeName === "Undeclared Cold Shear";

				if (isSystemDelayCode) return delayCodeName;

				let displayPath = delayCodePath;
				const maxLength = 40;

				if (delayCodePath && delayCodePath.length > maxLength) {
					let remainingPath = delayCodePath;

					while (
						remainingPath.length > maxLength &&
						remainingPath.includes("/")
					) {
						const firstSlashPos = remainingPath.indexOf("/");
						remainingPath = remainingPath.substring(firstSlashPos + 1);
					}

					if (remainingPath !== delayCodePath) {
						displayPath = ".../" + remainingPath;
					}
				}

				return displayPath;
			},
			flex: 3,
			cellStyle: {
				justifyContent: "flex-start",
			},
			wrapText: true,
			autoHeight: true,
		},
		{
			field: "Comments",
			headerName: "Comments",
			flex: 5,
			cellStyle: {
				justifyContent: "flex-start",
			},
			wrapText: true,
			autoHeight: true,
		},
	];
	return { columnDefs };
};
